import { render, staticRenderFns } from "./productFeature.vue?vue&type=template&id=6fba4db8&scoped=true&"
import script from "./productFeature.vue?vue&type=script&lang=js&"
export * from "./productFeature.vue?vue&type=script&lang=js&"
import style0 from "./productFeature.vue?vue&type=style&index=0&id=6fba4db8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba4db8",
  null
  
)

export default component.exports